import {
  catalogs,
  localeMeta,
  supportedLocales,
  type Locale,
  type TranslationParams,
} from '@/locales';

export type { Locale, TranslationParams };
export { localeMeta, supportedLocales };

const STORAGE_KEY = 'vsro_lang';

function isValidLocale(value: string | null | undefined): value is Locale {
  return Boolean(value && value in catalogs);
}

export function getLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isValidLocale(stored)) return stored;
  } catch {
    // WebView sin localStorage
  }
  return 'en';
}

export function setLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // ignore
  }
}

/** true si el usuario ya eligió idioma en este dispositivo */
export function hasStoredLocale(): boolean {
  try {
    return isValidLocale(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

export function getLocaleDir(locale: Locale = getLocale()): 'ltr' | 'rtl' {
  return localeMeta[locale]?.dir ?? 'ltr';
}

/**
 * Traduce una clave. Params opcionales reemplazan `{nombre}` en el texto.
 * @example t('bp_max_level', 'es', { level: 50 }) → "Nivel Máximo: 50"
 */
export function t(key: string, locale = getLocale(), params?: TranslationParams): string {
  let text = catalogs[locale]?.[key] ?? catalogs.en[key] ?? key;
  if (params) {
    for (const [name, value] of Object.entries(params)) {
      text = text.replaceAll(`{${name}}`, String(value));
    }
  }
  return text;
}

/** Lista para el selector de idioma (sidebar, settings, etc.) */
export const localeFlags = supportedLocales.map((code) => ({
  code,
  flagCode: localeMeta[code].flagCode,
  name: localeMeta[code].name,
}));
